<template>
	<v-row align="center" justify="center">
		<v-col cols="12" md="6" lg="5" xl="3">
			<Card class="card-mercadopago">
				<div class="logos-container">
					<div class="logo-seculos">
						<img src="@/assets/logo.png" alt="" />
					</div>
					<v-icon>mdi-plus</v-icon>
					<div class="logo-mercadopago">
						<img src="@/assets/mercadopagologo.svg" alt="" />
					</div>
				</div>

				<v-text-field
					v-model="this.$route.query.code"
					label="Código"
					filled
					rounded
					hide-details
					class="textField"
				/>

				<Botao color="success" texto="Copiar Código" @clicar="copiarCodigo()" grande />
			</Card>
		</v-col>
	</v-row>
</template>

<script>
import Card from '../components/shared/Card.vue'
import Botao from '../components/shared/Botao.vue'

export default {
	name: 'Exemplos',
	data: function () {
		return {}
	},
	components: {
		Card,
		Botao,
	},
	methods: {
		copiarCodigo() {
			navigator.clipboard.writeText(this.$route.query.code)
			this.$store.dispatch('showSuccess', 'Chave de Acesso copiada para o Clipboard!')
		},
	},
}
</script>
<style scoped>

.card-mercadopago{
	display: flex;
	flex-direction: column;
	gap: 2rem;
}
.textField {
	font-weight: 600;
	border-radius: 1rem;
}

.logos-container {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}

.logo-seculos img {
	width: 100px;
}

.logo-mercadopago {
	width: 150px;
}
</style>